define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/dom-attr",
	"dojo/store/Memory",
	"csi",
	"csi/form/Widget",
	"csi/locale",
	"csi/reflection",
	"csi/types",
	"csi/xml",
	"SiteAdmin/BusinessObject",
	"SiteAdmin/Locale"
], function(array, declare, attr, Memory, csi, Widget, locale, reflection, types, xml, BusinessObject, Locale) {

	return declare(Widget, {
		// Store: store for attribute drop-downs
		_attributeStore: null,

		// String: Business Object root class
		_typeNode: null,

		// Object: map of required attributes expressions - visibility above trumps required status
		_requiredExpressions: {
			DisplayNameAttribute1: "attr('DisplayNameAttribute2') != ''",
			DisplayNameAttribute2: "attr('DisplayNameAttribute1') != ''"
		},

		getFieldStore: function(/*csi.def.Field*/field, /*String*/value) {
			// summary: return same store for attribute fields
			if (this._attributeStore) {
				return this._attributeStore;
			}

			var cache = this.cacheView;
			var typeRoot = this._typeNode;
			var data = [];
			var usedAttrs = {};

			usedAttrs[xml.ATTR_NAME] = true;
			usedAttrs[xml.ATTR_TYPE] = true;

			var addAttribute = function(idAttr, typeAttr, formatAttr, typeNode) {
				if (usedAttrs[idAttr]) {
					return;
				}

				// don't allow string formats with special rendering
				if ((typeAttr == xml.ATTR_STRING) && formatAttr && (formatAttr != types.FORMAT_ALPHANUMERIC)) {
					return;
				}

				if ((typeAttr == xml.ATTR_STRING) || (typeAttr == xml.ATTR_ENUM) || xml.attributeTypeIsNumeric(typeAttr)) {
					usedAttrs[idAttr] = true;
					data.push({name: Locale.getTypeAttribute(typeNode, idAttr), id: idAttr});
				}
			};

			reflection.getClass(typeRoot).traverse(true, false, function(rc) {
				var nodeBO = cache.getParent(rc.getType(), "RootClassName");
				if (nodeBO) {
					// We show the attribute only if it belongs to the root class of the business object.
					// If the configurable attribute is not yet assigned to any class,
					// we can make sure that it will go to the root class checking that
					// the attribute class is the same as the root class
					var rcRootClass = BusinessObject.getRootClass(nodeBO);
					var bRoot = (nodeBO.RootClassName == nodeBO.AttributeClassName);
					var attrs = cache.getNodes(csi.objectValues(nodeBO.ConfigurableAttributes));

					array.forEach(attrs, function(nodeCA) {
						if (nodeCA && nodeCA.Enabled) {
							var rcOwner = reflection.getClass(nodeCA.ReflectionAttributeOwner);
							var rca = rcOwner ? rcOwner.getAttribute(nodeCA.ReflectionAttributeId) : null;

							if ((rcOwner == rcRootClass) || (!rcOwner && bRoot)) {
								addAttribute(Locale.getConfigurableAttributeId(nodeCA),
									rca ? rca.getType() : nodeCA[reflection.ATTR_VALUETYPE],
									rca ? rca.getFormat() : nodeCA[reflection.ATTR_FORMAT],
									typeRoot);
							}
						}
					});
				} else {
					// if not BO, then just iterate through reflection class attributes (not relations)
					array.forEach(rc.getAttributes(), function(rca) {
						addAttribute(rca.getId(), rca.isEnabled ? rca.getType() : null, rca.getFormat(), rc.getType());
					});
				}
			});

			data = csi.sort(data, "name");
			data.unshift({name: Locale.getTypeAttribute(typeRoot, xml.ATTR_TYPE), id: xml.ATTR_TYPE});
			data.unshift({name: Locale.getTypeAttribute(typeRoot, xml.ATTR_NAME), id: xml.ATTR_NAME});
			data.unshift({name: "", id: ""});

			this._attributeStore = new Memory({data: data});

			return this._attributeStore;
		},

		onValidateAttribute2: function(/*csi.def.View*/formView, /*csi.def.Field*/f2, /*Any*/value2, /*Object*/params) {
			// summary: validate attribute1 and attribute2
			var action = this.defView.m_formData.getAction();
			var f1 = this.defView.getField("DisplayNameAttribute1");
			var value1 = f1.getValue();

			if (value1) {
				if (value1 == value2) {
					// make sure attributes are not the same
					throw new Error(action.getString("_ErrorDuplicate"));
				} else if ((value1 != xml.ATTR_NAME) && (value2 != xml.ATTR_NAME)) {
					// Node Name attribute missing
					throw new Error(action.getString("_ErrorNoName", [Locale.getTypeName(this._typeNode)]));
				}
			}
		},

		_buildFields: function(/*csi.def.Field[]*/fields) {
			// summary: perform custom draw for most fields
			var defView = this.defView;
			var f;

			this._typeNode = BusinessObject.getRootType(this.getFormSourceNode());

			// remove plural field if it does not already exist
			var plural = Locale.getTypeResource(this._typeNode, locale.TYPE_PLURAL);
			if (!plural) {
				defView.removeField("LocalePlural");
				defView.removeFieldFromArray(fields, "LocalePlural");
			}

			this.inherited(arguments);

			f = defView.getField("LocaleName");
			const typeName = Locale.getTypeName(this._typeNode);
			const baseTypeName = Locale.getBaseConfigResolver().getTypeName(this._typeNode);
			attr.set(f.m_control, "value", typeName);

			if (plural) {
				f = defView.getField("LocalePlural");
				attr.set(f.m_control, "value", plural);
			}

			f = defView.getField("LocaleTooltip");
			attr.set(f.m_control, "value", Locale.getTypeResource(this._typeNode, locale.TYPE_TOOLTIP));

			// C8-37484: if there is no display name, make bottom half of the form read-only.  this is part of the deprecation effort
			if (typeName == baseTypeName) {
				this.setFieldDisabled("DisplayNameAttribute1", true);
				this.setFieldDisabled("DisplayNameSeparator", true);
				this.setFieldDisabled("DisplayNameAttribute2", true);
			}
		}
	});
});